import { ReactElement, useEffect, useState } from 'react'
import NoHeaderAndFooterLayout from 'layouts/NoHeaderAndFooterLayout'
import MetaTags from 'components/MetaTags'
import { defaultMeta } from 'shared/constants'
import { QueryClient, dehydrate, useQuery } from 'react-query'
import { useRouter } from 'next/router'
import { AxiosError } from 'axios'
import LoadingState from 'components/OurResults/LoadingState'
import OurPartnersApi from 'api/OurPartners'
import OurPartners from 'components/OurPartners'

export async function getServerSideProps() {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery(['defaultOurPartnersData'], () =>
    OurPartnersApi.getDefaultPageData(),
  )

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  }
}

const DefaultOurPartnersPage = () => {
  const [isClient, setIsClient] = useState(false)
  const router = useRouter()

  const {
    data: OurPartnersData,
    isFetching,
    error,
  } = useQuery('defaultOurPartnersData', () => OurPartnersApi.getDefaultPageData())

  useEffect(() => {
    if (error) {
      if ((error as AxiosError).response?.status === 404) {
        router.push('/')
      }
    }
  }, [error, router, OurPartnersData])

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient || isFetching || !OurPartnersData) return <LoadingState />

  if (!OurPartnersData.results.length) {
    router.push('/')
    return null
  }

  return (
    <>
      <MetaTags data={defaultMeta} />
      <OurPartners data={OurPartnersData.results[0]} />
    </>
  )
}

DefaultOurPartnersPage.getLayout = function getLayout(page: ReactElement) {
  return <NoHeaderAndFooterLayout>{page}</NoHeaderAndFooterLayout>
}

export default DefaultOurPartnersPage
